// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goods-list-box .van-tabs__nav {\n  padding: 0 0.53333rem;\n}\n.goods-list-box .van-tab {\n  padding: 0 !important;\n  width: fit-content;\n  flex: unset !important;\n  font-size: 0.34667rem;\n  font-weight: 500;\n  color: #656565;\n  margin-right: 0.45333rem;\n}\n.goods-list-box .van-tab--active {\n  font-size: 0.45333rem;\n  font-weight: bold;\n  color: #252424;\n}\n.goods-list-box .van-tabs__line {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
